import { render, staticRenderFns } from "./AccountSettingsPageContainer.vue?vue&type=template&id=39b008af&"
import script from "./AccountSettingsPageContainer.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports